var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Box, ResponsiveContext } from "grommet";
import { useContext } from "react";
import styled from "styled-components";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { routes } from "../../../const/routes";
import { times } from "../../../utils/date";
import { InfoImage } from "../InfoImage";
import { SmallImage } from "../SmallImage";
var StyledGridBox = styled(Box)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  display: grid;\n  grid-template-rows: auto;\n  gap: 24px;\n",
    ]))
);
export var NewsMainSection = function NewsMainSection(_ref) {
  var as = _ref.as,
    app_api = _ref.app_api,
    newsList = _ref.newsList;
  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);
  return /*#__PURE__*/ React.createElement(
    StyledGridBox,
    {
      style: {
        gridTemplateColumns: isMobileWidth
          ? "repeat(auto-fit, minmax(280px, 1fr))"
          : "repeat(4, 1fr)",
      },
    },
    (newsList == null ? void 0 : newsList.length) > 0
      ? /*#__PURE__*/ React.createElement(
          React.Fragment,
          null,
          /*#__PURE__*/ React.createElement(
            Box,
            {
              style: {
                gridArea: isMobileWidth ? "auto / auto / auto / auto" : "1 / 1 / span 2 / span 2",
              },
            },
            /*#__PURE__*/ React.createElement(InfoImage, {
              image: app_api + newsList[0].banners.preview,
              heading: newsList[0].headline,
              paragraph: newsList[0].subtitle,
              publication_date: times.getFullDate(newsList[0].publication_date),
              link: routes.news.path + "/" + newsList[0].public_id,
              as: as,
            })
          ),
          newsList.slice(1, 5).map(function (newsItem) {
            return /*#__PURE__*/ React.createElement(
              Box,
              {
                key: newsItem.public_id,
              },
              /*#__PURE__*/ React.createElement(SmallImage, {
                image: app_api + newsItem.banners.small,
                heading: newsItem.headline,
                publication_date: times.getFullDate(newsItem.publication_date),
                link: routes.news.path + "/" + newsItem.public_id,
                as: as,
              })
            );
          })
        )
      : null
  );
};
